import type { ReapproNeedAdjustmentDTO, ReapproNeedAdjustmentScope } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface UpsertReapproNeedAdjustmentArgs {
  categoryId: number
  scope: ReapproNeedAdjustmentScope
  storeId?: number
  deliveryDate: string
  multiplier: number
}

export const upsertReapproNeedAdjustment = async ({
  categoryId,
  scope,
  storeId,
  deliveryDate,
  multiplier,
}: UpsertReapproNeedAdjustmentArgs) => {
  const response = await gozokiApiWithAuth.post<{ adjustment: ReapproNeedAdjustmentDTO }>(
    `/reappro-categories/${categoryId}/need-adjustments`,
    { scope, storeId, deliveryDate, multiplier },
  )
  return response.data.adjustment
}

export const deleteReapproNeedAdjustment = async ({
  categoryId,
  adjustmentId,
}: {
  categoryId: number
  adjustmentId: number
}) => {
  await gozokiApiWithAuth.delete(
    `/reappro-categories/${categoryId}/need-adjustments/${adjustmentId}`,
  )
}

export interface BulkUpsertReapproNeedAdjustmentsArgs {
  categoryId: number
  includeTagIds: number[]
  excludeTagIds: number[]
  deliveryDate: string
  multiplier: number
}

export interface BulkUpsertReapproNeedAdjustmentsResult {
  storeIds: number[]
  created: number
  updated: number
  unchanged: number
}

export const bulkUpsertReapproNeedAdjustments = async ({
  categoryId,
  includeTagIds,
  excludeTagIds,
  deliveryDate,
  multiplier,
}: BulkUpsertReapproNeedAdjustmentsArgs) => {
  const response = await gozokiApiWithAuth.post<BulkUpsertReapproNeedAdjustmentsResult>(
    `/reappro-categories/${categoryId}/need-adjustments/bulk`,
    { includeTagIds, excludeTagIds, deliveryDate, multiplier },
  )
  return response.data
}

export const bulkDeleteReapproNeedAdjustments = async ({
  categoryId,
  adjustmentIds,
}: {
  categoryId: number
  adjustmentIds: number[]
}) => {
  const response = await gozokiApiWithAuth.post<{ deleted: number }>(
    `/reappro-categories/${categoryId}/need-adjustments/bulk-delete`,
    { adjustmentIds },
  )
  return response.data
}
